import { observable } from 'mobx';

class AdvertisementEditorStore {
  @observable moduleId = null;
  @observable id = null;
  @observable pageId = null;
  @observable published = false;

  @observable name = '';
  @observable marketplaceProductId = '';
  @observable product = {};
  @observable offers = [];
  @observable offer = {};
  @observable tags = [];
  @observable language = '';
  @observable signLanguage = false;

  @observable content = '';
  @observable playerMedia = null;
  @observable mediaVideoUrl = null;

  @observable media = {};
  @observable image = {};

  @observable dripping = {};
  @observable upsell = [];

  @observable loaded = true;

  snapshot = {};
}

export default new AdvertisementEditorStore();
